import ApolloClient from 'apollo-boost'

import { getCurrentSession } from '../lib/authentication'

const client = new ApolloClient({
  uri: `${OE_ENV.API_GATEWAY_URL}/graphql`,
  request: async (operation) => {
    const { idToken: authorization = '' } = await getCurrentSession()
    operation.setContext({ headers: { authorization } })
  }
})

export default client
